import React, { Component } from 'react';
import { Row, Col, Input, Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import AnalyticsWidget from './AnalyticsWidget';
import ReactDragListView from 'react-drag-listview'
import './Analytics.css';

class AnalyticsDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dashboards: [],
            editActive: false,
        };
    }

    componentDidMount() {
        this.props.log('AnalyticsDashboard.js/componentDidMount');
        this.getDashboards();
    }

    getDashboards = () => {
        this.props.log('AnalyticsDashboard.js/getDashboards');
        fetch('/api/dashboards/' + this.props.user, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        dashboards: results.data
                    });
                } else {
                    this.props.addToast('Unable to load dashboards.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleChange = (widgetId, key, val) => {
        this.props.log('AnalyticsDashboard.js/handleChange (widgetId, key, val)', widgetId, key, val);
        this.setState((prevState) => {
            let sel = prevState;
            const index = sel.dashboards.findIndex(item => item.widgetId === parseInt(widgetId));
            if (sel.dashboards[index].userConfiguration == null) sel.dashboards[index].userConfiguration = {};
            if (sel.dashboards[index].userConfiguration[key] == null) sel.dashboards[index].userConfiguration[key] = null;
            sel.dashboards[index].userConfiguration[key] = val;
            return sel;
        }, () => this.reorder())
    }

    reorder = (data = [...this.state.dashboards]) => {
        this.props.log('AnalyticsDashboard.js/reorder()');
        let dbDashboards = [];
        let counter = 0;
        data = data.map((dashboard) => {
            let newOrder = null;
            if (dbDashboards.findIndex(item => item.widgetId === dashboard.widgetId) === -1) {
                dbDashboards.push({ widgetId: dashboard.widgetId })
                newOrder = (dashboard.userActive ? ((counter + 1) * 10) : null);
                if (dashboard.userActive) counter++;
            }
            return { ...dashboard, userOrder: newOrder }
        })
        this.setState({ dashboards: data }, () => {
            fetch('/api/dashboards/' + this.props.user, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken
                },
                body: JSON.stringify(
                    { dashboards: data }
                )
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
        });
    }

    render() {
        this.props.info('AnalyticsDashboard.js/render');
        const dragProps = {
            onDragEnd: (fromIndex, toIndex) => {
                // console.log(fromIndex, toIndex)
                const data = [...this.state.dashboards];
                const item = data.splice(fromIndex, 1)[0];
                data.splice(toIndex, 0, item);
                this.reorder(data);
            },
            nodeSelector: 'div.widget',
            handleSelector: 'div.dragIcon',
            className: 'w-100'
        };
        return (
            <>
                <Row>
                    <Col md={2} className="text-left">{!this.state.editActive ? <Button onClick={() => this.setState({ editActive: true })} color="primary">Configure</Button> : <></>}</Col>
                    <Col md={8}><h2>My Dashboard</h2></Col>
                    <Col md={2}></Col>
                </Row>
                <Row>
                    {this.state.editActive ?
                        <Col md={4} className="text-left">
                            <Row>
                                <Col md={12}>
                                    {[...this.state.dashboards].sort((a, b) => a.order - b.order).map(item => (
                                        <div key={item.widgetId}>
                                            <Input
                                                type="checkbox"
                                                checked={this.props.isFieldNull(item.userActive, true)}
                                                name={"widget_" + item.widgetId}
                                                onChange={(e) => this.setState((prevState) => {
                                                    // console.log(e.target.name)
                                                    let sel = prevState;
                                                    sel.dashboards.filter(item => ("widget_" + item.widgetId) === (e.target.name))[0].userActive = !sel.dashboards.filter(item => ("widget_" + item.widgetId) === (e.target.name))[0].userActive
                                                    return sel;
                                                }, () => this.reorder())}
                                            />
                                            {item.name}
                                        </div>
                                    ))}
                                </Col>
                            </Row>
                            <Row>
                                <Button onClick={() => this.setState({ editActive: false })} color="success">OK</Button>
                            </Row>
                        </Col>
                        : <></>}
                    <Col md={this.state.editActive ? 8 : 12}>
                        <ReactDragListView.DragColumn {...dragProps}>
                            <Row>
                                {this.state.dashboards.sort((a, b) => a.userOrder - b.userOrder).map((item) => (
                                    <AnalyticsWidget
                                        {...this.props}
                                        key={item.widgetId}
                                        id={item.widgetId}
                                        name={item.name}
                                        types={item.types}
                                        widget={item}
                                        widths={(item.configuration != null && item.configuration.widths != null && item.configuration.widths.length > 0) ? item.configuration.widths : [6]}
                                        width={(item.userConfiguration != null && item.userConfiguration.width != null && item.userConfiguration.width > 0) ? item.userConfiguration.width :
                                            ((item.configuration != null && item.configuration.defaultWidth != null && item.configuration.defaultWidth > 0) ? item.configuration.defaultWidth : 6)}
                                        active={item.userActive}
                                        handleChange={this.handleChange}
                                    />
                                ))}
                            </Row>
                        </ReactDragListView.DragColumn>
                    </Col>
                </Row>
            </>
        );
    }
}

export default AnalyticsDashboard;
